export default __webpack_public_path__ + "static/media/FUNZIONI_ESECUTIVE_ICONA.0a675cfc.svg";